export default "__VITE_ASSET__BKwx9Btf__"